// Date wording for the public home page. Times are shown in the visitor's own time zone,
// with the zone name, in US format (as the rest of the app).

const DAY_MS = 24 * 60 * 60 * 1000;

const toDate = (value) => (value instanceof Date ? value : new Date(value));

const startOfLocalDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

export function formatEventDate(start) {
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'long', month: 'long', day: 'numeric', year: 'numeric'
  }).format(toDate(start));
}

/** "10:00 PM to 2:00 AM GMT+5", or with dates when the fair runs longer than a day. */
export function formatEventTimeRange(start, end) {
  const s = toDate(start);
  const e = toDate(end);
  const long = e - s > DAY_MS;
  const base = long ? { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' } : { hour: 'numeric', minute: '2-digit' };
  const from = new Intl.DateTimeFormat('en-US', base).format(s);
  const to = new Intl.DateTimeFormat('en-US', { ...base, timeZoneName: 'short' }).format(e);
  return `${from} to ${to}`;
}

/** Whole calendar days from today to the start, in the visitor's time zone. */
export function daysUntil(start, now = new Date()) {
  return Math.round((startOfLocalDay(toDate(start)) - startOfLocalDay(now)) / DAY_MS);
}

export function eventTiming(start, end, now = new Date()) {
  const s = toDate(start);
  const e = toDate(end);
  if (now >= s && now < e) return { live: true, text: 'Happening now' };
  const days = daysUntil(s, now);
  if (days <= 0) return { live: false, text: 'Opens today' };
  if (days === 1) return { live: false, text: 'Opens tomorrow' };
  return { live: false, text: `Opens in ${days} days` };
}
